"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMatchScorePercentage = calculateMatchScorePercentage;
function calculateMatchScorePercentage(totalScore) {
    if (totalScore.weight === 0) {
        return undefined;
    }
    return ((1 + totalScore.score / totalScore.weight) / 2) * 100;
}
